/**
 * Organization membership status helpers.
 *
 * The backend serializes `InvitationStatus` as the enum *name*
 * (`WaitingRegistration` | `WaitingConfirmation` | `Accepted` | `Declined`), so a
 * check against the literal string `'pending'` never matches and lets unaccepted
 * members through as active ones. Every status test goes through these helpers.
 */

/** Member has been invited but has not accepted yet. */
export function isPendingMember(status?: string | null): boolean {
  const normalized = String(status ?? '').toLowerCase();
  return (
    normalized === 'pending' ||
    normalized === 'waitingregistration' ||
    normalized === 'waitingconfirmation'
  );
}

/** Member has declined the invitation. */
export function isDeclinedMember(status?: string | null): boolean {
  return String(status ?? '').toLowerCase() === 'declined';
}

/**
 * Member is a full participant of the organization. An empty status is treated as
 * accepted because some list endpoints omit the field for already-joined members.
 */
export function isAcceptedMember(status?: string | null): boolean {
  const normalized = String(status ?? '').toLowerCase();
  return !normalized || normalized === 'accepted';
}
